import { render, staticRenderFns } from "./RelatorioEmailModal.vue?vue&type=template&id=72296b0e"
import script from "./RelatorioEmailModal.vue?vue&type=script&lang=js"
export * from "./RelatorioEmailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports